// extracted by mini-css-extract-plugin
module.exports = {"normal":"Footer_normal__1Nq5j","footer":"Footer_footer__3QXZY","copy":"Footer_copy__25lHN","link":"Footer_link__2DeFF"};